const BASE_URL = '/assets/data/'

export const ENDPOINT_GENNEMSNITLON_PERSONGRUPPER = `${BASE_URL}gnslon_persgrupper.min.json`
export const ENDPOINT_UNDERGRUPPER = `${BASE_URL}undergrupper.min.json`
export const ENDPOINT_STATISTICS_EXPERIENCE = `${BASE_URL}statistics-experience.min.json`
export const ENDPOINT_STATISTICS_EDUCATION = `${BASE_URL}statistics-education.min.json`
export const ENDPOINT_LOENSEKTORER = `${BASE_URL}loen-sektorer.min.json`
export const ENDPOINT_FORDELINGSTAL = `${BASE_URL}fordelingstal.min.json` 
export const ENDPOINT_FORDELINGSTAL_ACCUMULATED = `${BASE_URL}fordelingstal-accumulated-numbers.min.json` 
export const ENDPOINT_DELELEMENTER = `${BASE_URL}delelementer.min.json`
export const ENDPOINT_GROUPS = `${BASE_URL}groups.min.json`


const headersDefault = Object.freeze({
  'Content-Type': 'application/json'
})


export const getEndpoint = (ENDPOINT, POST = false, payload) => {
  const options = {
    method: POST ? 'POST' : 'GET',
    headers: {...{}, ...headersDefault},
    ...POST && payload && {body: JSON.stringify({...{}, ...payload})}
  }

  return fetch(ENDPOINT, options)
    .then(res => res)
    .then(res => res.json())
    .catch(error => console.log(error))
}
